import { user_info } from "@/api/user";
import { setLocal, getLocal } from "@/utils/utils";

const state = {
  isLogin: false
}
const getters = {
}
const mutations = {
  SET_IS_LOGIN (state, value) {
    state.isLogin = Boolean(value)
  }
}
const actions = {
  // 检查是否登录
  checkLogin ({ commit }) {
    return new Promise((resolve, reject) => {
      let token = getLocal('m-token');
      let userInfo = getLocal('userInfo')
      if (token && userInfo) {
        commit('SET_IS_LOGIN', true)
        resolve(userInfo)
      } else {
        commit('SET_IS_LOGIN', false)
        reject(Error('not login'))
      }
    })
  },
  setIsLogin ({ commit }, value) {
    commit('SET_IS_LOGIN', value)
  },
  updateUserInfo () {
    return user_info()
      .then(res => {
        // console.log(res);
        setLocal('userInfo', res)
        return res
      })
  },
  clearUserInfo ({ commit }) {
    commit('SET_IS_LOGIN', false)
    setLocal('userInfo', '')
    setLocal('m-token', '')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
